import { useEffect, useState } from 'react';

import { Delay } from '@/shared/constants/delay.constant';

type UseDebounceHook = (value: string | boolean, delay?: number) => string | boolean;

/**
 * Hook to get debounced value
 * @param {string} [value] - Type of input value
 * @returns string - Returns debounced value that update after specified delay
 * @example
 * const debouncedValue = useDebounce(value);
 */

export const useDebounce: UseDebounceHook = (value, delay = Delay.Average) => {
	const [debouncedValue, setDebouncedValue] = useState(value);

	useEffect(() => {
		const handler = setTimeout(() => {
			setDebouncedValue(value);
		}, delay);

		return () => {
			clearTimeout(handler);
		};
	}, [delay, value]);

	return debouncedValue;
};
